import React, { useEffect, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { withRouter } from "react-router-dom";

const MarcasModal = ({
    modalId,
    title,
    warning,
    textArea,
    popUpId,
    centerButton,
    desc,
    handleConfirm,
    type,
}) => {
    const [obsc, setObsc] = useState("");
    const [required, setRequired] = useState({
        obsc: false,
    });

    const onClickHandler = () => {
        handleConfirm(type, obsc);
    };
    const onChangeHandler = (e) => {
        if (!e.target.value) {
            setRequired({ ...required, obsc: true });
        } else {
            setRequired({ ...required, obsc: false });
        }
        setObsc(e.target.value);
    };

    return (
        <>
            <div className="modal center" id={modalId}>
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div
                            class="modal-header popheader"
                            style={{ paddingBottom: "10px" }}
                        >
                            {/* <span className="k-icon k-i-warning mt-1 k-icon-new-nivel2"></span> */}
                            <h5 class="modal-title mr-auto" id="ModalLabel">
                                {title}
                            </h5>
                        </div>
                        <div style={{ maxWidth: "90%", margin: "0 auto" }}>
                            {desc}
                        </div>
                        {warning && (
                            <div
                                className="col-md-12 rotuloMessageMainDiv  "
                                style={{ maxWidth: "90%", margin: "0 auto" }}
                            >
                                <div className="rotuloMessageChildDiv">
                                    <span
                                        style={{
                                            marginTop: "3px",
                                            marginRight: "10px",
                                        }}
                                        className="k-icon k-i-information"
                                    />
                                    <label>
                                        Este processo encontra-se em validação
                                    </label>
                                </div>
                            </div>
                        )}

                        {textArea && (
                            <div>
                                <div
                                    className="form-group"
                                    style={{
                                        margin: "0 auto",
                                        maxWidth: "90%",
                                    }}
                                >
                                    <label htmlFor="">Observações</label>
                                    <textarea
                                        class="form-control"
                                        value={obsc}
                                        onChange={onChangeHandler}
                                    ></textarea>
                                    {required.obsc && (
                                        <span className="text-danger">
                                            Campo obrigatório
                                        </span>
                                    )}
                                </div>
                            </div>
                        )}

                        <div
                            class={`modal-footer popfooter ${
                                centerButton && "justify-content-center"
                            }`}
                        >
                            <Button
                                type="button"
                                name="no"
                                className="k-primary btn-ivdp-secondary"
                                data-dismiss="modal"
                            >
                                Cancelar
                            </Button>
                            <Button
                                type="button"
                                name="yes"
                                className="k-button k-primary btn-ivdp-primary"
                                data-dismiss="modal"
                                data-toggle="modal"
                                data-target={`#${popUpId}`}
                                onClick={onClickHandler}
                                disabled={
                                    (type === "cancel" || type === "suspend") &&
                                    obsc === ""
                                }
                            >
                                Confirmar
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default withRouter(MarcasModal);
